<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		At A Glance
		<div (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square" style="position: relative; top: 5px;"></div>
	</div>
</div>
<div *ngIf="!toggled" class="col-lg-12 h-100 jmWidgetPadding" id="atAGlanceWidget" style="overflow-y:auto;">
	<div class="jmWidgetHeaderContainer">
		<div class="jmPageTitle" style="padding-bottom: 10px;">
			At A Glance
			<div (click)="toggleCollapse()" *ngIf="showMinimize" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="top:10px;"></div>
		</div>
	</div>

	<table class="text-info" [ngStyle]="{'width':'100%','height':showMinimize?'unset':'95%'}">
		<colgroup><col style="width:30px"><col></colgroup>
		<tbody>
			<tr *ngFor="let item of iconList" style="vertical-align: top;">
				<td>
					<i *ngIf="item.iconType==='css'" class="{{item.icon}} text-center" style="font-size:20px !important"></i>
					<span *ngIf="item.iconType==='html'" class="text-center" [innerHtml]="item.icon"></span>
				</td>
				<td>
					<div class="jmSupportText">{{item.text}}</div>
					<div style="margin:0px; padding:0px;">
						<span *ngIf="item.dataType==='html'" class="jmDataFontSize" [innerHTML]="item.data | safe:'html'"></span>
						<span *ngIf="item.dataType==='text'" class="jmDataFontSize">{{item.data}}</span>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
</div>
